"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.tab.posts': 'Post',
    'socialMediaPlan.tab.calendar': 'Calendario',
    'socialMediaPlan.tab.history': 'Attività',
};
